/* tslint:disable */
/* eslint-disable */
/**
 * Mr.Bilit Authentication api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, RequiredError } from '../base';
// @ts-ignore
import { CheckUserMobileResponse } from '../model';
// @ts-ignore
import { LoginViaTemporaryCodeByEmailResponse } from '../model';
// @ts-ignore
import { TokenTypes } from '../model';
// @ts-ignore
import { TokenValidationRequest } from '../model';
// @ts-ignore
import { TokenValidationResponse } from '../model';
/**
 * TokenApiApiTokenApiCheckMobileGet - axios parameter creator
 * 
 * @param {string} [mobile] 
 * @param {boolean} [sendToken] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function TokenApiApiTokenApiCheckMobileGetAxiosParamCreator (mobile?: string, sendToken?: boolean, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Token/api/CheckMobile`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (mobile !== undefined) {
        localVarQueryParameter['mobile'] = mobile;
    }

    if (sendToken !== undefined) {
        localVarQueryParameter['sendToken'] = sendToken;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * TokenApiApiTokenGet - axios parameter creator
 * 
 * @summary  (Auth policies: aut:Token)
 * @param {string} [uniqueId] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function TokenApiApiTokenGetAxiosParamCreator (uniqueId?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Token`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (uniqueId !== undefined) {
        localVarQueryParameter['uniqueId'] = uniqueId;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * TokenApiApiTokenPost - axios parameter creator
 * 
 * @param {number} [source] 
 * @param {TokenValidationRequest} [tokenValidationRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function TokenApiApiTokenPostAxiosParamCreator (source?: number, tokenValidationRequest?: TokenValidationRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Token`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (source !== undefined) {
        localVarQueryParameter['source'] = source;
    }



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(tokenValidationRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * TokenApiApiTokenSendByemailGet - axios parameter creator
 * 
 * @param {string} [email] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function TokenApiApiTokenSendByemailGetAxiosParamCreator (email?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Token/send/byemail`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (email !== undefined) {
        localVarQueryParameter['email'] = email;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * TokenApiApiTokenSendByemailV2Get - axios parameter creator
 * 
 * @param {string} [email] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function TokenApiApiTokenSendByemailV2GetAxiosParamCreator (email?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Token/send/byemail/v2`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (email !== undefined) {
        localVarQueryParameter['email'] = email;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * TokenApiApiTokenSendGet - axios parameter creator
 * 
 * @param {string} [mobile] 
 * @param {TokenTypes} [tokenType] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function TokenApiApiTokenSendGetAxiosParamCreator (mobile?: string, tokenType?: TokenTypes, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Token/send`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (mobile !== undefined) {
        localVarQueryParameter['mobile'] = mobile;
    }

    if (tokenType !== undefined) {
        localVarQueryParameter['tokenType'] = tokenType;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}

/**
 * Request parameters for apiTokenApiCheckMobileGet operation in TokenApi.
 * @export
 * @interface TokenApiApiTokenApiCheckMobileGetRequest
 */
export interface TokenApiApiTokenApiCheckMobileGetRequest {
    /**
     * 
     * @type {string}
     * @memberof TokenApiApiTokenApiCheckMobileGet
     */
    readonly mobile?: string

    /**
     * 
     * @type {boolean}
     * @memberof TokenApiApiTokenApiCheckMobileGet
     */
    readonly sendToken?: boolean
}

/**
 * Request parameters for apiTokenGet operation in TokenApi.
 * @export
 * @interface TokenApiApiTokenGetRequest
 */
export interface TokenApiApiTokenGetRequest {
    /**
     * 
     * @type {string}
     * @memberof TokenApiApiTokenGet
     */
    readonly uniqueId?: string
}

/**
 * Request parameters for apiTokenPost operation in TokenApi.
 * @export
 * @interface TokenApiApiTokenPostRequest
 */
export interface TokenApiApiTokenPostRequest {
    /**
     * 
     * @type {number}
     * @memberof TokenApiApiTokenPost
     */
    readonly source?: number

    /**
     * 
     * @type {TokenValidationRequest}
     * @memberof TokenApiApiTokenPost
     */
    readonly tokenValidationRequest?: TokenValidationRequest
}

/**
 * Request parameters for apiTokenSendByemailGet operation in TokenApi.
 * @export
 * @interface TokenApiApiTokenSendByemailGetRequest
 */
export interface TokenApiApiTokenSendByemailGetRequest {
    /**
     * 
     * @type {string}
     * @memberof TokenApiApiTokenSendByemailGet
     */
    readonly email?: string
}

/**
 * Request parameters for apiTokenSendByemailV2Get operation in TokenApi.
 * @export
 * @interface TokenApiApiTokenSendByemailV2GetRequest
 */
export interface TokenApiApiTokenSendByemailV2GetRequest {
    /**
     * 
     * @type {string}
     * @memberof TokenApiApiTokenSendByemailV2Get
     */
    readonly email?: string
}

/**
 * Request parameters for apiTokenSendGet operation in TokenApi.
 * @export
 * @interface TokenApiApiTokenSendGetRequest
 */
export interface TokenApiApiTokenSendGetRequest {
    /**
     * 
     * @type {string}
     * @memberof TokenApiApiTokenSendGet
     */
    readonly mobile?: string

    /**
     * 
     * @type {TokenTypes}
     * @memberof TokenApiApiTokenSendGet
     */
    readonly tokenType?: TokenTypes
}

/**
* 
* @param {TokenApiApiTokenApiCheckMobileGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function TokenApiApiTokenApiCheckMobileGet(requestParameters: TokenApiApiTokenApiCheckMobileGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await TokenApiApiTokenApiCheckMobileGetAxiosParamCreator(requestParameters.mobile, requestParameters.sendToken, options, configuration);
    const request: () => AxiosPromise<CheckUserMobileResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary  (Auth policies: aut:Token)
* @param {TokenApiApiTokenGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function TokenApiApiTokenGet(requestParameters: TokenApiApiTokenGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await TokenApiApiTokenGetAxiosParamCreator(requestParameters.uniqueId, options, configuration);
    const request: () => AxiosPromise<string> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {TokenApiApiTokenPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function TokenApiApiTokenPost(requestParameters: TokenApiApiTokenPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await TokenApiApiTokenPostAxiosParamCreator(requestParameters.source, requestParameters.tokenValidationRequest, options, configuration);
    const request: () => AxiosPromise<TokenValidationResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {TokenApiApiTokenSendByemailGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function TokenApiApiTokenSendByemailGet(requestParameters: TokenApiApiTokenSendByemailGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await TokenApiApiTokenSendByemailGetAxiosParamCreator(requestParameters.email, options, configuration);
    const request: () => AxiosPromise<boolean> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {TokenApiApiTokenSendByemailV2GetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function TokenApiApiTokenSendByemailV2Get(requestParameters: TokenApiApiTokenSendByemailV2GetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await TokenApiApiTokenSendByemailV2GetAxiosParamCreator(requestParameters.email, options, configuration);
    const request: () => AxiosPromise<LoginViaTemporaryCodeByEmailResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {TokenApiApiTokenSendGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function TokenApiApiTokenSendGet(requestParameters: TokenApiApiTokenSendGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await TokenApiApiTokenSendGetAxiosParamCreator(requestParameters.mobile, requestParameters.tokenType, options, configuration);
    const request: () => AxiosPromise<boolean> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
